import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {
  InspectionCaseDto,
  InspectionFireExtinguishers
} from '@authority-labs/api-interfaces';
import { Conclusion } from '@authority-labs/enums';

@Component({
  selector: 'authority-labs-fire-extinguishers-test-results',
  templateUrl: './fire-extinguishers-test-results.component.html',
  styleUrls: ['./fire-extinguishers-test-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class FireExtinguishersTestResultsComponent implements OnInit {
  @Input() inspection: InspectionFireExtinguishers;
  notes: string[] = [];

  ngOnInit(): void {
    this.notes = new InspectionFireExtinguishers(this.inspection)
      .getNotes()
      .filter((note) => note.addNotesToReport && note.notes)
      .filter((note) => !note.notes.includes('undefined'))
      .map((note) => note.notes);
  }

  getConclusion(checkCase: InspectionCaseDto): string {
    if (checkCase.isApplicable) {
      return checkCase.isPassed ? Conclusion.Pass : Conclusion.Fail;
    }

    return Conclusion.NotApplicable;
  }
}
